import { r as registerInstance, h, H as Host } from './index-c269755a.js';

// Create a const where all members have a readonly value
// and literal type by using const assertion.
const ParagraphVariant = {
  PARAGRAPH100: 'paragraph-100',
  PARAGRAPH200: 'paragraph-200',
  PREAMBLE100: 'preamble-100',
  PREAMBLE200: 'preamble-200',
  ADDITIONAL100: 'additional-100',
  OVERLINE100: 'overline-100',
  OVERLINE200: 'overline-200',
};

const teliaPCss = ":host{--telia-p-hyphenation:\"auto\";display:block}.telia-p{hyphens:var(--telia-p-hyphenation);margin:0}.telia-p--paragraph-100{font-family:\"TeliaSans\", Helvetica, Arial, \"Lucida Grande\", sans-serif;font-weight:normal;font-size:calc(1.6rem * var(--voca-rem-multiplier));line-height:1.5}.telia-p--paragraph-200{font-family:\"TeliaSans\", Helvetica, Arial, \"Lucida Grande\", sans-serif;font-weight:normal;font-size:calc(1.6rem * var(--voca-rem-multiplier));line-height:1.75}.telia-p--preamble-100{font-family:\"TeliaSans\", Helvetica, Arial, \"Lucida Grande\", sans-serif;font-weight:normal;font-size:calc(2rem * var(--voca-rem-multiplier));line-height:1.5}.telia-p--preamble-200{font-family:\"TeliaSans\", Helvetica, Arial, \"Lucida Grande\", sans-serif;font-weight:normal;font-size:calc(2rem * var(--voca-rem-multiplier));line-height:1.5}@media screen and (min-width: 37.5em){.telia-p--preamble-200{font-size:calc( calc(2rem * var(--voca-rem-multiplier)) + 0.4 * (100vw - calc(60rem * var(--voca-rem-multiplier))) / 84 )}}@media screen and (min-width: 90em){.telia-p--preamble-200{font-size:calc(2.4rem * var(--voca-rem-multiplier))}}.telia-p--additional-100{font-family:\"TeliaSans\", Helvetica, Arial, \"Lucida Grande\", sans-serif;font-weight:normal;font-size:calc(1.4rem * var(--voca-rem-multiplier));line-height:1.5}.telia-p--overline-100{font-family:\"TeliaSans\", Helvetica, Arial, \"Lucida Grande\", sans-serif;font-weight:500;font-size:calc(1.4rem * var(--voca-rem-multiplier));letter-spacing:0.1rem;line-height:1;text-transform:uppercase}.telia-p--overline-200{font-family:\"TeliaSans\", Helvetica, Arial, \"Lucida Grande\", sans-serif;font-weight:500;font-size:calc(1.4rem * var(--voca-rem-multiplier));letter-spacing:0.1rem;line-height:1;text-transform:uppercase}@media screen and (min-width: 37.5em){.telia-p--overline-200{font-size:calc( calc(1.4rem * var(--voca-rem-multiplier)) + 0.2 * (100vw - calc(60rem * var(--voca-rem-multiplier))) / 84 )}}@media screen and (min-width: 90em){.telia-p--overline-200{font-size:calc(1.6rem * var(--voca-rem-multiplier))}}";

const TeliaP = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    /**
     * Determines the appearance of the text.
     *
     */
    this.variant = ParagraphVariant.PARAGRAPH100;
    /**
     * Disable hyphenation
     *
     */
    this.disableHyphenation = false;
    /** Tracking id is used to identify and count Component usage */
    this.dataTrackingId = 'telia-p';
  }
  render() {
    return (h(Host, { style: {
        '--telia-p-hyphenation': this.disableHyphenation ? 'none' : 'auto',
      }, class: `telia-p--${this.variant}` }, h("p", { class: {
        'telia-p': true,
        [`telia-p--${this.variant}`]: !!this.variant,
      } }, h("slot", null), h("telia-vst", { dataTrackingId: this.dataTrackingId }))));
  }
};
TeliaP.style = teliaPCss;

export { TeliaP as telia_p };
